import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import {
  SidebarWrapperContent,
  SidebarWrapperFooter,
} from '@/components/atoms/SidebarWrapper/SidebarWrapper';
import { Button } from '@/components/ui/button';
import useDatasources from '@/hooks/useDatasources';
import { createOAuthURL } from '@/hooks/useIntercom';
import { selectAccountSlug } from '@/redux/session/selectors';
import { extractNames, generateUniqueName } from '@/util/util';

import { EXTERNAL_SOURCE_FOOTER, EXTERNAL_SOURCE_SECTION } from './layout';

type IntercomFormProps = { handleCancel: () => void };

export const IntercomForm = ({ handleCancel }: IntercomFormProps) => {
  // Redux selectors
  const slug = useSelector(selectAccountSlug);

  // Hooks
  const { collectionId } = useParams();
  const { datasources } = useDatasources(collectionId);
  const { t } = useTranslation();

  const openIntercomOauth = async () => {
    const knowledgeBases = datasources?.filter((datasource) => datasource.type === 'intercom_kb');

    const uniqueName = generateUniqueName(
      `Intercom ${t('collections.knowledge_base')}`,
      extractNames(knowledgeBases)
    );

    const intercomUrl = await createOAuthURL(slug, undefined, collectionId, uniqueName);

    window.open(intercomUrl, '_self');
  };

  const handleRedirect = () => {
    openIntercomOauth();
  };

  return (
    <>
      <SidebarWrapperContent className={EXTERNAL_SOURCE_SECTION}>
        <h3 className="mb-1 text-sm leading-5 font-medium">
          {t('collections.datasources.intercom_redirect')}
        </h3>
        <p className="text-xs leading-5 text-foreground-muted">
          {t('collections.datasources.intercom_access')}
        </p>
      </SidebarWrapperContent>
      <SidebarWrapperFooter className={EXTERNAL_SOURCE_FOOTER}>
        <Button type="button" variant="ghost-neutral" onClick={handleCancel}>
          {t('common.cancel')}
        </Button>
        <Button type="button" onClick={handleRedirect}>
          {t('collections.redirect')}
        </Button>
      </SidebarWrapperFooter>
    </>
  );
};
